import React from 'react'
import USTemplateDefault from 'src/components/template/us'
export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    title="Stream live TV and sports"
    subtitle="Watch from your laptop or mobile device"
    tagline="No inflight Wi-Fi purchase necessary."
  />
)
